import { trigger, state, stagger, transition, query, style, animate, group, keyframes } from '@angular/animations';

export function createMasterAnimation(triggerName){
    return trigger(triggerName, [
        state('background', style({transform: 'translateX(calc(-100% - 15px))', opacity: 0, display: 'none'})),
		state('foreground', style({transform: 'translateX(calc(0% - 15px))', opacity: 1, display: 'block'})),

		transition("foreground <=> background", animate('0.5s ease-in-out'))
    ]);
}

export function createDetailAnimation(triggerName){
    return trigger(triggerName, [
        state('background', style({transform: 'translateX(calc(100% + 15px))', opacity: 0, display: 'none'})),
		state('foreground', style({transform: 'translateX(calc(0% - 15px))', opacity: 1, display: 'block'})),

		transition("foreground <=> background", animate('0.5s ease-in-out'))
    ]);
}
